import React from 'react';
import { connect } from 'react-redux';
import s from './style.css';
import { vault } from '../../actions';
const MovingFileView = (props) => {
    if (!props.file)
        return null;
    return (React.createElement("div", { className: s.container },
        React.createElement("p", null,
            "Moving ",
            React.createElement("b", null, props.file.name)),
        React.createElement("p", null, "Go to your destination folder and confirm"),
        React.createElement("div", { className: s.buttonsContainer },
            React.createElement("button", { type: 'button', className: `${s.button} ${s.cancel}`, onClick: props.cancelMovingFile }, "Cancel"),
            React.createElement("button", { type: 'submit', className: `${s.button} ${s.confirm}`, onClick: () => {
                    if (props.file?.folder === props.currentFolder.id) {
                        alert('Cannot move file to the same folder');
                        return;
                    }
                    props.moveFile(props.file, props.currentFolder);
                } }, "Confirm"))));
};
const mapStateToProps = (state) => ({
    file: state.appTemp.movingFile,
    currentFolder: state.appTemp.folderStack[state.appTemp.folderStack.length - 1],
});
const connector = connect(mapStateToProps, { ...vault });
export default connector(MovingFileView);
